import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { binLabelFormatSchema } from "./print-bin-labels";

export const printLocationLabels = {
  name: "printLocationLabels" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    format: binLabelFormatSchema,
  }),
  output: z.object({ url: z.string() }),
};
